import React from 'react';
import FranzPodcast from '../FranzPodcast';

import imageSrc from './s7Podcast.jpg';

const SiePodcast = () => {
  return (
    <FranzPodcast
      imageSrc={imageSrc}
      description="Interested in audio lessons so you can study during your commute? The Series 7 Podcast has more than 33 hours of course material. Whether you're doing yardwork, walking your dog, or exercising at the gym, you can turn it into productive study time. Try six lessons for free to see if it could be a good supplement for your study habits."
      url="https://www.series7podcast.com/series-7-study-guide-audio_classes/?utm_source=achievable"
      cta="Learn more"
    />
  );
};

export default SiePodcast;
